import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from 'axios'
import $store from '@/store/index.js'
import $url from '@/assets/config/address-config.js'

import routeConfig from './router-config.js'

Vue.use(VueRouter); //安装vue-router

const router = new VueRouter({  //注册vue-router实例
    mode : 'history',
    routes : routeConfig,
    history: false,
    hashbang: true
});

export default router;
	

router.beforeEach((to,from,next)=>{
    // 包含onceToken
    let onceToken = to.query.token;
    
    if( onceToken ){  

        let url = `${$url.sass}/token`
        //验证onceToken
        return axios.post(url,{
            once_token:onceToken,
            cmd:'token_login',
            "53kf_token":'Aj|uU620cjJ`53kf'
        },{
            transformRequest: [function (data) {
                let ret = ''
                for (let it in data) {
                    ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
                }
                return ret
            }],
        })
        .then(({data:{server_response:res}}) => {
            if(res.token){
                sessionStorage.setItem('token',res.token);
                next()
            }else{
                next({name:'error'})
            }
        })
        .catch(err=>{
            console.log(111);
            
            next({name:'error'})
        })
    }



    let pages = ['login','wait','noPermission','error'];
    if(pages.some(name=>to.name == name)){
        next();
        return;
    }


    // 正常页面
    let code;  //访问页面所需权限
    $store.dispatch("getUserInfo")
    .then(info=>{
        if(!info.ecsEmployee){ //没有登录信息  登录验证
            // 跳到官网
            window.location.href = `${$url.eiisys_supplier}?action=logout`
            next()
            return;
        }
        if(to.matched.some(record => record.meta.code && (code = record.meta.code + '') ) ){   //有权限限制
            if($store.getters.userCodes.some(val=> val==code)){
                next();
            }else{
                next({name:'noPermission'});  //权限不足
            }
        }else{
            next();
        }
    })
})